import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { FiEyeOff } from "react-icons/fi";
import { T } from "../pages/TodoTask/constants/todoTokens";

/**
 * Marks a task whose assignee roster is private.
 *
 * Render ONLY for privileged viewers (creator / admin / support / acknowledgedBy).
 * Showing this to a plain assignee tells them other assignees exist, which is
 * exactly what the flag prevents — so every call site gates on canSeeAssignees().
 *
 * Neutral slate on purpose: teal is taken by the recurring "R" chip and violet
 * by the cron "C" chip, and privacy is metadata, not status or urgency.
 */
const PrivateBadge = ({ compact = false, dark = false, onMouseDown }) => {
  const fg = dark ? "#CBD5E1" : T.textSub;
  return (
    <Tooltip
      title="Assignees are private — each assignee sees only their own line"
      placement="top"
      arrow
      disableInteractive
    >
      <Box
        onMouseDown={onMouseDown}
        sx={{
          display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "3px",
          px: compact ? "4px" : "6px", py: "2px", borderRadius: "20px",
          bgcolor: dark ? "rgba(203,213,225,0.12)" : T.borderLight,
          border: `1px solid ${dark ? "rgba(203,213,225,0.28)" : T.border}`,
          cursor: "default", flexShrink: 0,
        }}
      >
        <FiEyeOff size={8} color={fg} />
        {!compact && (
          <Typography
            sx={{
              fontSize: "9.5px", fontWeight: 800, color: fg,
              fontFamily: "'Inter', sans-serif", letterSpacing: "0.03em",
            }}
          >
            PRIVATE
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default React.memo(PrivateBadge);
